import { useContext, useEffect, useState } from "react";
import {
  FaEye,
  FaDownload,
  FaIdCard,
  FaFileAlt,
  FaCheckCircle,
  FaExclamationTriangle,
  FaSpinner,
} from "react-icons/fa";
import { AppContext } from "../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ManageApplication = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingChallan, setLoadingChallan] = useState(false);
  const [loadingAdmitCard, setLoadingAdmitCard] = useState(false);
  const [feeData, setFeeData] = useState(null);
  const [loadingFeeData, setLoadingFeeData] = useState(false);
  const [testSettings, setTestSettings] = useState({
    test_date: "", // Default value
    test_time: "", // Default value
    interview_date: "", // Default value
    interview_time: "", // Default value
  });

  console.log("intwrview  date", testSettings.interview_date);
  const [loadingTestSettings, setLoadingTestSettings] = useState(false);
  const {
    studentInfo,
    loginUserEmail,
    studentDetails,
    setStudentDetails,
    academicRecords,
    setAcademicRecords,
  } = useContext(AppContext);

  const handleDownloadPDFVoucher = () => {
    setLoadingChallan(true);

    const ChallanCopy = ({ title }) => (
      <div className="flex-1 border border-gray-300 p-6 relative bg-white">
        {" "}
        {/* Added more spacing */}
        <div className="flex justify-between items-start mb-2">
          <div className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="University Logo"
              className="w-[60px] h-[60px] object-contain"
            />
            <div>
              <h2 className="font-bold text-base">{title}</h2>
              <h3 className="font-semibold text-sm">
                {challanData.university}
              </h3>
            </div>
          </div>
        </div>
        <div className="text-xs mb-2">
          <p>Credited At: {challanData.bank}</p>
          <p>Collection A/C # {challanData.accountNo}</p>
          <p>Collecting Branches: {challanData.accountTitle}</p>
        </div>
        <div className="grid grid-cols-2 gap-2 text-xs mb-2">
          <div>
            <p>Issue Date: {challanData.issueDate}</p>
            <p>Student ID #: {challanData.studentID}</p>
            <p>Fee Voucher No: {challanData.feeVoucherNo}</p>
          </div>
          <div>
            <p>Name: {challanData.name}</p>
            <p>Program: {challanData.program}</p>
            <p>Session: {challanData.session}</p>
          </div>
        </div>
        <table className="w-full text-xs mb-4">
          <thead>
            <tr>
              <th className="text-left py-2 px-3 bg-black text-white">
                Description
              </th>
              <th className="text-right py-2 px-3 bg-black text-white">
                Amount
              </th>
            </tr>
          </thead>
          <tbody className="border bg-white">
            {challanData.fees.map((fee, index) => (
              <tr key={index} className="border-b">
                <td className="py-2 px-3">{fee.description}</td>
                <td className="text-right py-2 px-3">{fee.amount}</td>
              </tr>
            ))}
            <tr className="font-bold">
              <td className="py-2 px-3">Total Receivable:</td>
              <td className="text-right py-2 px-3">
                {challanData.totalReceivable}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="text-xs mb-10 mt-5">
          <p>Due Date: {challanData.dueDate}</p>
          <div className="mt-5">
            <p>Received By: _________________</p>
          </div>
        </div>
        <div className="text-center text-xs mt-4">
          <p className="font-bold">ONLINE GENERATED CHALLAN</p>

          <p className="text-[10px]">
            These funds are intended for NASTP INSTITUTE OF INFO. TECHNOLOGY
            Collection A/C # 0113-0980-007942-01-8 held with Tufail Road Branch,
            Lahore
          </p>
          <p className="text-[10px] mt-1 font-medium">
            The fee can also be paid at the NIIT admission office.
          </p>
          <p>
            NASTP Institute of Information Technology, Lahore 69 Abid Majeed
            Road, Cantt, Lahore, Punjab.
          </p>
        </div>
        {/* <div className="text-center text-[10px] ">
        </div> */}
      </div>
    );

    // Create a temporary div for rendering
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.innerHTML = `
      <div id="pdf-content" style="width: 1200px; background-color: white;">
        <div style="display: flex; gap: 1px;">
          ${ReactDOMServer.renderToString(<ChallanCopy title="Bank Copy" />)}
          ${ReactDOMServer.renderToString(
            <ChallanCopy title="Institute Copy" />
          )}
          ${ReactDOMServer.renderToString(<ChallanCopy title="Student Copy" />)}
        </div>
      </div>
    `;
    document.body.appendChild(tempDiv);

    const input = tempDiv.querySelector("#pdf-content");
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: true,
      backgroundColor: "#ffffff",
      windowWidth: 1200,
      windowHeight: 800,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = 20;

        pdf.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );
        pdf.save("fee-challan.pdf");

        // Remove the temporary div
        document.body.removeChild(tempDiv);
        setLoadingChallan(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        setLoadingChallan(false);
      });
  };

  const downloadAdmitCard = async () => {
    setLoadingAdmitCard(true);

    // Create a hidden div for rendering
    const admitCardDiv = document.createElement("div");
    admitCardDiv.style.position = "absolute";
    admitCardDiv.style.left = "-9999px";
    admitCardDiv.style.top = "-9999px";

    admitCardDiv.innerHTML = `
     <center>
  <div style="margin-top: 20px;">
        
        <h1 style="font-size: 24px; margin-bottom: 8px;">
                ${
                  studentInfo && studentInfo.level === "Undergraduate Programs"
                    ? "ADMIT CARD"
                    : "INTERVIEW CARD"
                }
            </h1>
        
         
       </div>
  </center>
  <div style="padding: 40px;  background: white; width: 800px; font-family: Arial, sans-serif;">
 
    <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
      <div style="display: flex; align-items: center; ">
        <img 
          src="/logo.png" 
          alt="Institute Logo" 
          style="width: 80px; height: 80px; object-fit: contain; margin-right: 10px; margin-top: 25px; margin-bottom: 8px;"
        />
        <div>
         
          <p>
          
           ${
             studentInfo && studentInfo.level === "Undergraduate Programs"
               ? "Admit Card For Admission Test Fall 2025"
               : "Interview for Postgraduate Admissions - Fall 2025"
           }
          
          
          </p>
          <p style="font-weight: 600;">NASTP Institute of Information Technology</p>
        </div>
      </div>
      <div style="width: 120px; height: 140px; border: 1px solid #ccc; ">
        <img 
          src="${process.env.REACT_APP_API_URL}/${studentDetails.image}"
          style="width: 100%; height: 100%; object-fit: cover;"
          alt="Student Photo"
        />
      </div>
    </div>
    
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
      <div>
        <p style="color: #666; font-size: 14px;">Student ID</p>
        <p style="font-weight: 500;">${studentDetails?.cnic || ""}</p>
      </div>
      <div>
        <p style="color: #666; font-size: 14px;">
        
         ${
           studentInfo && studentInfo.level === "Undergraduate Programs"
             ? "Test Date"
             : "Interview Date"
         }
        </p>
       <p style="font-weight: 500;">
  ${
    studentInfo && studentInfo.level === "Undergraduate Programs"
      ? testSettings.test_date
      : testSettings.interview_date
  }
</p>

      </div>
      <div>
        <p style="color: #666; font-size: 14px;">
         ${
           studentInfo && studentInfo.level === "Undergraduate Programs"
             ? "Admit Card No."
             : "Interview Card No"
         }
        
        </p>
        <p style="font-weight: 500;">${studentDetails?.feeVocherNo || ""}</p>
      </div>
      <div>
        <p style="color: #666; font-size: 14px;">
         ${
           studentInfo && studentInfo.level === "Undergraduate Programs"
             ? "Test Time"
             : "Interview Time"
         }
        
        
        </p>
        <p style="font-weight: 500;">
        
        ${
          studentInfo && studentInfo.level === "Undergraduate Programs"
            ? testSettings.test_time
            : testSettings.interview_time
        }
        
        
        </p>
      </div>
      <div>
        <p style="color: #666; font-size: 14px;">Name</p>
        <p style="font-weight: 500;">${studentDetails?.name}</p>
      </div>
      <div>
        <p style="color: #666; font-size: 14px;">Father's Name</p>
        <p style="font-weight: 500;">${studentDetails?.fatherName}</p>
      </div>
      <div>
        <p style="color: #666; font-size: 14px;">Program</p>
        <p style="font-weight: 500;">${studentDetails.program}</p>
      </div>
    </div>

    <div style="margin-top: 80px; background: #f5f5f5; padding: 16px; text-align: center;">
      <h2 style="font-size: 14px; font-weight: 600; margin-bottom: 8px;">
      
       ${
         studentInfo && studentInfo.level === "Undergraduate Programs"
           ? "ADMISSION TEST CENTRE"
           : "INTERVIEW VENUE"
       }
      
      </h2>
      <p style="color: #666; font-size: 14px; margin: 0;">NASTP Institute of Information Technology, Lahore
69 Abid Majeed Road, Cantt, Lahore, Punjab.</p>
      <div style="margin-top: 12px; ">
      <center>
      <img 
      src="/NIIT-QR-Code.png" 
      alt="NIIT Location QR Code" 
      style="width: 120px; height: 120px; object-fit: contain;"
      />
      <p style="font-size: 12px; color: #333; margin-top: 6px;">Scan the QR code to view the location on Google Maps</p>
      </center>
      </div>


      

      <h2 style="font-size: 14px; font-weight: 600; margin-top: 24px; margin-bottom: 8px;">IMPORTANT INSTRUCTIONS FOR CANDIDATES:</h2>
 <p style="font-weight: 100; text-align: left;">
    ${
      studentInfo && studentInfo.level === "Undergraduate Programs"
        ? `<ul style="color: #666; font-size: 14px; margin-left: 20px; text-align: left; display: inline-block;">
        <li>Arrive at the test center at least 30 minutes before the scheduled start time.</li>
        <li>Bring the following items on the test day:
          <ul style="margin-left: 20px;">
            <li>Admit Card</li>
            <li>Original CNIC or B-Form</li>
            <li>Lead pencil and ballpoint pen</li>
          </ul>
        </li>
        <li>Electronic devices such as calculators, mobile phones, smartwatches, or any digital/electronic gadgets are strictly prohibited in the examination hall.</li>
        <li>Parking is not permitted inside the campus. Please arrange for pick and drop accordingly.</li>
      </ul>`
        : `
      <ul style="color: #666; font-size: 14px; margin-left: 20px; text-align: left; display: inline-block;">
  <li>Reach the venue at NASTP Institute of Information Technology at the specified time and date mentioned above.</li>
  <li>Bring the following documents for verification:</li>
  <li>
    <ul style="margin-left: 20px;">
      <li>All original academic degrees and transcripts</li>
      <li>Result of Admission Test (NTS GAT / HEC HAT / GRE) or Proof of registration for the aforementioned test</li>
    </ul>
  </li>
  <li>Candidates must submit the final result of the admission test by August 20, 2025. Late submission of test results may affect admission eligibility.</li>
</ul>
`
    }
  </p>


    </div>
  </div>
`;

    // Append to body temporarily
    document.body.appendChild(admitCardDiv);

    try {
      // Generate PDF
      const canvas = await html2canvas(admitCardDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 20;

      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("admit-card.pdf");
    } catch (error) {
      console.error("Error generating admit card:", error);
    } finally {
      // Clean up: remove the temporary div
      document.body.removeChild(admitCardDiv);
      setLoadingAdmitCard(false);
    }
  };

  const handleViewClick = async () => {
    navigate("/ShowStudentForm");
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!loginUserEmail) {
        toast.error("No student info found.");
        return;
      }

      setLoading(true);
      const token = localStorage.getItem("token"); // Get the token from localStorage (or from context)

      if (!token) {
        toast.error("Authorization token is missing!");
        return;
      }

      try {
        // Fetch student details with "allInfo=1"
        const studentResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/students/student-info?email=${loginUserEmail}&allInfo=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add token to the headers
            },
          }
        );
        setStudentDetails(studentResponse.data);

        // Fetch academic records
        const academicResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/students/academic-records?email=${loginUserEmail}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add token to the headers
            },
          }
        );
        setAcademicRecords(academicResponse.data);
        // navigate("/ShowStudentForm"); // Uncomment if you want to navigate after fetching
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load student information. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // Call the async function inside useEffect
  }, [loginUserEmail]); // Add loginUserEmail as a dependency to trigger on change

  useEffect(() => {
    const fetchFeeData = async () => {
      if (!loginUserEmail) return;

      setLoadingFeeData(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/fees/fetch-fee-records`, {
          params: { email: loginUserEmail },
        });

        if (
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          // Use the fee record for the current logged-in user
          const userFeeData = response.data.data[0];
          setFeeData(userFeeData);
        }
      } catch (error) {
        console.error("Error fetching fee data:", error);
      } finally {
        setLoadingFeeData(false);
      }
    };

    fetchFeeData();
  }, [loginUserEmail]);

  // Fetch test date and time settings
  useEffect(() => {
    const fetchTestSettings = async () => {
      setLoadingTestSettings(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/settings/test-settings`);

        if (response.data) {
          // Format the date from ISO to readable format
          let formattedDate = "JULY 22, 2024 - MONDAY"; // Default fallback
          let formattedTime = "02:00 pm"; // Default fallback
          let formattedInterviewDate = "JULY 22, 2024 - MONDAY"; // Default fallback
          let formattedInterviewTime = "02:00 pm"; // Default fallback

          if (response.data.test_date) {
            try {
              const date = new Date(response.data.test_date);
              const options = {
                year: "numeric",
                month: "long",
                day: "numeric",
                weekday: "long",
              };
              formattedDate = date
                .toLocaleDateString("en-US", options)
                .toUpperCase();
            } catch (e) {
              console.error("Error formatting date:", e);
            }
          }

          if (response.data.test_time) {
            try {
              // Handle time format - could be "10:30:00" or something else
              const timeParts = response.data.test_time.split(":");
              let hours = parseInt(timeParts[0]);
              const minutes = timeParts[1];
              const ampm = hours >= 12 ? "pm" : "am";
              hours = hours % 12;
              hours = hours ? hours : 12; // Convert 0 to 12
              formattedTime = `${hours}:${minutes} ${ampm}`;
            } catch (e) {
              console.error("Error formatting time:", e);
            }
          }

          if (response.data.test_date) {
            try {
              const date = new Date(response.data.test_date);
              const options = {
                year: "numeric",
                month: "long",
                day: "numeric",
                weekday: "long",
              };
              formattedDate = date
                .toLocaleDateString("en-US", options)
                .toUpperCase();
            } catch (e) {
              console.error("Error formatting date:", e);
            }
          }

          if (response.data.test_time) {
            try {
              // Handle time format - could be "10:30:00" or something else
              const timeParts = response.data.test_time.split(":");
              let hours = parseInt(timeParts[0]);
              const minutes = timeParts[1];
              const ampm = hours >= 12 ? "pm" : "am";
              hours = hours % 12;
              hours = hours ? hours : 12; // Convert 0 to 12
              formattedTime = `${hours}:${minutes} ${ampm}`;
            } catch (e) {
              console.error("Error formatting time:", e);
            }
          }

          if (response.data.interview_date) {
            try {
              const date = new Date(response.data.interview_date);
              const options = {
                year: "numeric",
                month: "long",
                day: "numeric",
                weekday: "long",
              };
              formattedInterviewDate = date
                .toLocaleDateString("en-US", options)
                .toUpperCase();
            } catch (e) {
              console.error("Error formatting date:", e);
            }
          }

          if (response.data.interview_time) {
            try {
              // Handle time format - could be "10:30:00" or something else
              const timeParts = response.data.interview_time.split(":");
              let hours = parseInt(timeParts[0]);
              const minutes = timeParts[1];
              const ampm = hours >= 12 ? "pm" : "am";
              hours = hours % 12;
              hours = hours ? hours : 12; // Convert 0 to 12
              formattedInterviewTime = `${hours}:${minutes} ${ampm}`;
            } catch (e) {
              console.error("Error formatting time:", e);
            }
          }

          setTestSettings({
            test_date: formattedDate,
            test_time: formattedTime,
            interview_date: formattedInterviewDate,
            interview_time: formattedInterviewTime,
          });
        }
      } catch (error) {
        console.error("Error fetching test settings:", error);
        // Keep the default values if there's an error
      } finally {
        setLoadingTestSettings(false);
      }
    };

    fetchTestSettings();
  }, []);

  // Use dynamic data if available, otherwise fallback to static values
  const challanData = {
    university: (
      <div>
        NASTP INSTITUTE OF <br /> INFORMATION TECHNOLOGY
      </div>
    ),
    bank: feeData?.account_title || "",
    accountNo: feeData?.account_number || "",
    accountTitle: feeData?.account_title || "",
    issueDate: new Date().toLocaleDateString("en-GB"),
    studentID: feeData?.student_id || studentDetails?.cnic || "",
    feeVoucherNo: feeData?.feeVocherNo || "",
    name: feeData?.name || studentDetails?.name || "",
    program: feeData?.program || studentDetails?.program || "",
    session: feeData?.session || "",
    fees: [
      { description: "Admission Application Fee", amount: "3000.00" },
      { description: "Library Fee", amount: "0.00" },
      { description: "Tuition Fee", amount: ".00" },
      { description: "Registration Fee", amount: ".00" },
      { description: "Examination Fee", amount: ".00" },
      { description: "Others", amount: ".00" },
    ],
    totalReceivable: "3000.00",
    dueDate: feeData?.due_date
      ? new Date(feeData.due_date).toLocaleDateString("en-GB")
      : "05/02/2025",
  };

  // Loading spinner component
  const LoadingSpinner = () => (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
    </div>
  );

  // Button loading spinner
  const ButtonSpinner = () => <FaSpinner className="animate-spin mr-2" />;

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
      />
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="container max-w-6xl mx-auto px-4">
          {studentInfo == null ? (
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl">
              {/* Empty state with animation */}
              <div className="bg-gradient-to-r from-blue-700 to-blue-900 text-white font-bold p-4 flex items-center">
                <FaExclamationTriangle className="mr-2" /> Form Status
              </div>
              <div className="p-8 space-y-6">
                <div className="flex flex-col items-center justify-center py-10">
                  <div className="bg-blue-50 p-4 rounded-full mb-4">
                    <FaFileAlt className="text-blue-500 text-4xl" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    No Application Found
                  </h3>
                  <p className="text-gray-600 text-center max-w-md">
                    You haven't submitted your application form yet. Please
                    complete and submit your form to proceed.
                  </p>
                  {/* <button
                    onClick={() => navigate("/application-form")}
                    className="mt-6 bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex items-center"
                  >
                    <FaFileAlt className="mr-2" /> Start Application
                  </button> */}
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-6">
              {/* Application status card */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl">
                <div className="bg-gradient-to-r from-blue-700 to-blue-900 p-5">
                  <h3 className="text-xl font-bold text-white flex items-center">
                    <FaCheckCircle className="mr-2" /> Application Status
                  </h3>
                  <p className="text-blue-100 text-sm mt-1">
                    Manage your application details and download important
                    documents
                  </p>
                </div>

                {/* Student info summary */}
                <div className="p-6 bg-blue-50 border-b border-blue-100">
                  <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="h-14 w-14 bg-blue-200 text-blue-700 rounded-full flex items-center justify-center">
                        <span className="text-lg font-bold">
                          {studentInfo.name?.charAt(0) || "A"}
                        </span>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800">
                          {studentInfo.name}
                        </h4>
                        <p className="text-sm text-gray-500">
                          Application ID: {studentInfo.id}
                        </p>
                      </div>
                    </div>
                    <div className="mt-4 sm:mt-0">
                      <span className="bg-green-100 text-green-800 text-xs font-medium px-3 py-1 rounded-full">
                        {studentInfo.program}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Action cards */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* View Application Card */}
                  <div className="bg-white border border-gray-200 rounded-lg p-5 hover:shadow-md transition-all duration-300 flex flex-col items-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3">
                      <FaEye className="text-blue-600 text-xl" />
                    </div>
                    <h5 className="font-medium text-gray-800 mb-2">
                      View Application
                    </h5>
                    <p className="text-gray-500 text-sm text-center mb-4">
                      Review your submitted application details
                    </p>
                    <button
                      onClick={handleViewClick}
                      className="mt-auto w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded transition-colors duration-300"
                    >
                      View Details
                    </button>
                  </div>

                  {/* Fee Challan Card */}
                  <div className="bg-white border border-gray-200 rounded-lg p-5 hover:shadow-md transition-all duration-300 flex flex-col items-center">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-3">
                      <FaFileAlt className="text-amber-600 text-xl" />
                    </div>
                    <h5 className="font-medium text-gray-800 mb-2">
                      Fee Challan
                    </h5>
                    <p className="text-gray-500 text-sm text-center mb-4">
                      Download your fee challan for payment
                    </p>
                    <button
                      onClick={handleDownloadPDFVoucher}
                      disabled={loadingChallan}
                      className={`mt-auto w-full py-2 px-4 rounded transition-colors duration-300 flex items-center justify-center
                        ${
                          loadingChallan
                            ? "bg-amber-400 cursor-wait"
                            : "bg-amber-600 hover:bg-amber-700"
                        } text-white`}
                    >
                      {loadingChallan ? (
                        <ButtonSpinner />
                      ) : (
                        <FaDownload className="mr-2" />
                      )}
                      {loadingChallan ? "Processing..." : "Download"}
                    </button>
                  </div>

                  {/* Admit Card */}
                  <div className="bg-white border border-gray-200 rounded-lg p-5 hover:shadow-md transition-all duration-300 flex flex-col items-center">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-3">
                      <FaIdCard className="text-green-600 text-xl" />
                    </div>
                    <h5 className="font-medium text-gray-800 mb-2">
                      Admit Card
                    </h5>
                    <p className="text-gray-500 text-sm text-center mb-4">
                      Download your entrance test admit card
                    </p>
                    <button
                      onClick={downloadAdmitCard}
                      disabled={
                        studentInfo.admit_card != "1" || loadingAdmitCard
                      }
                      className={`mt-auto w-full py-2 px-4 rounded transition-all duration-300 flex items-center justify-center
                        ${
                          loadingAdmitCard
                            ? "bg-green-400 cursor-wait"
                            : studentInfo.admit_card == "1"
                            ? "bg-green-600 hover:bg-green-700 text-white"
                            : "bg-gray-200 text-gray-500 cursor-not-allowed"
                        }`}
                    >
                      {loadingAdmitCard ? (
                        <ButtonSpinner />
                      ) : (
                        <FaDownload className="mr-2" />
                      )}
                      {loadingAdmitCard
                        ? "Processing..."
                        : studentInfo.admit_card == "1"
                        ? "Download"
                        : "Not Available"}
                    </button>
                  </div>
                </div>

                {/* Application timeline/status */}
                <div className="px-6 pb-6">
                  <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3">
                    Application Timeline
                  </h4>
                  <div className="relative">
                    <div className="absolute left-5 inset-0 h-full w-0.5 bg-gray-200"></div>
                    <ul className="space-y-4">
                      <li className="relative flex items-start">
                        <div className="absolute left-0 rounded-full bg-green-500 p-1">
                          <div className="h-2 w-2 rounded-full bg-white"></div>
                        </div>
                        <div className="ml-10">
                          <p className="font-medium text-gray-800">
                            Application Submitted
                          </p>
                          <p className="text-xs text-gray-500">
                            Your application has been successfully submitted
                          </p>
                        </div>
                      </li>
                      <li className="relative flex items-start">
                        <div
                          className={`absolute left-0 rounded-full p-1 ${
                            studentInfo.admit_card == "1"
                              ? "bg-green-500"
                              : "bg-gray-300"
                          }`}
                        >
                          <div className="h-2 w-2 rounded-full bg-white"></div>
                        </div>
                        <div className="ml-10">
                          <p className="font-medium text-gray-800">
                            Payment Status
                          </p>
                          <p className="text-xs text-gray-500">
                            {studentInfo.admit_card == "1"
                              ? "Payment received"
                              : "Awaiting payment confirmation"}
                          </p>
                        </div>
                      </li>
                      <li className="relative flex items-start">
                        <div
                          className={`absolute left-0 rounded-full p-1 ${
                            studentInfo.admit_card == "1"
                              ? "bg-green-500"
                              : "bg-gray-300"
                          }`}
                        >
                          <div className="h-2 w-2 rounded-full bg-white"></div>
                        </div>
                        <div className="ml-10">
                          <p className="font-medium text-gray-800">
                            Admit Card
                          </p>
                          <p className="text-xs text-gray-500">
                            {studentInfo.admit_card == "1"
                              ? "Admit card is available for download"
                              : "Admit card will be available soon"}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ManageApplication;
